import clsx from 'clsx'
import { FullLoader } from 'components/atoms/FullLoader/FullLoader'
import { NoSearchResult } from 'components/templates/NoSearchResult/NoSearchResult'
import { Button, StackIcon } from 'shared/ui'

import { Creating } from '../CreateModal/Creating'
import { NoCampaignsYetTemplate } from './NoCampaignsYetTemplate'
import css from './Page.module.css'
import { Search } from './Search'
import { Statuses } from './Statuses'
import { TableCampaigns } from './Table'
import { useLoadTable } from './useLoadTable'

const NoFilterCampaignResult = () => (
	<NoSearchResult
		className={css.empty}
		lead='Please, change your search query or status filter to get results.'
	/>
)

function ArchiveCampaignsPage() {
	const { isEmptyFilterResult, props, query, setPage } = useLoadTable()

	if (query.isLoading) {
		return <FullLoader />
	}

	props.campaigns = props.campaigns?.toReversed()

	return (
		<main className={clsx('main app-scroll', css.root)}>
			{query.isSuccess && !isEmptyFilterResult && (
				<>
					<h1 className={css.title}>Campaigns</h1>

					<Search setPage={setPage} />
				</>
			)}
			{isEmptyFilterResult ? (
				<NoFilterCampaignResult />
			) : (
				<TableCampaigns {...props} archive />
			)}
		</main>
	)
}

function CampaignsPage() {
	const {
		isEmptyFilterResult,
		isHasItems,
		isNotExistAtAll,
		props,
		query,
		setPage
	} = useLoadTable()

	if (query.isLoading) {
		return <FullLoader />
	}

	return (
		<main className={clsx('main app-scroll', css.root)} id='campaigns'>
			{query.isSuccess && !isNotExistAtAll && (
				<>
					<h1 className={css.title}>Campaigns</h1>
					<Search setPage={setPage} />

					<Statuses key='✅' />
					<Button className={css.add} key='➕' onClick={Creating.open}>
						<StackIcon icon='plus' />
						Add campaign
					</Button>
				</>
			)}
			{isNotExistAtAll && <NoCampaignsYetTemplate />}
			{isEmptyFilterResult && <NoFilterCampaignResult />}
			{isHasItems && <TableCampaigns {...props} />}
			<Creating />
		</main>
	)
}

export { ArchiveCampaignsPage, CampaignsPage }
